// React Lib
import React, { useState, useEffect } from "react";
// Component Styles
import { useStyles } from "./OverflowMenuSelectionStyles";
import { StyledEngineProvider } from "@mui/material";
// @otg-one/ui_components/components
import { Checkmark } from "../../icons";
// @otg-one/ui_components/constants
import { Color } from "../../constants/Colors";
// Material UI Core
import { Menu, MenuItem, popoverClasses } from "@mui/material";
export const OverflowMenuSelection = (props) => {
    const classes = useStyles(props);
    const [activeItem, setActiveItem] = useState("");
    const { id, setValue, anchorElement, menuItems, setAnchorEl, selectedItem, withCheckMark, menuWidth } = props;
    useEffect(() => {
        setActiveItem(selectedItem);
    }, []);
    const closeAllMenus = () => {
        setAnchorEl(null);
    };
    const handleItemClick = (menuItem) => () => {
        setActiveItem(menuItem.text);
        setValue(menuItem.text);
        menuItem.onClick();
        closeAllMenus();
    };
    const renderMenuItem = (menuItem) => {
        const isSelected = activeItem === menuItem.text;
        return (React.createElement(MenuItem, { key: menuItem.text, className: classes.menuItem.styles, onClick: handleItemClick(menuItem) },
            withCheckMark && (React.createElement("div", { className: classes.menuItemCheckIcon, style: {
                    color: isSelected ? Color.primary[500] : "transparent"
                } },
                React.createElement(Checkmark, null))),
            React.createElement("div", { className: classes.menuItemText }, menuItem.text)));
    };
    return (React.createElement(StyledEngineProvider, { injectFirst: true },
        React.createElement(Menu, { id: id, anchorEl: anchorElement, classes: {
                paper: classes.menuRoot,
                list: classes.menuList
            }, sx: {
                [`& .${popoverClasses.paper}`]: {
                    width: menuWidth ? menuWidth : 280
                }
            }, PopoverClasses: {
                root: classes.popoverRoot
            }, keepMounted: true, open: Boolean(anchorElement), onClose: closeAllMenus }, menuItems.map(menuItem => renderMenuItem(menuItem)))));
};
